import { defineMeta } from '@/registry/types';

export const dividerMeta = defineMeta({
  name: 'Divider',
  level: 'atom',
  category: 'layout',
  classification: 'themed-mui',
  description: 'Thin rule to separate content or groups. Themed MUI Divider.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Divider',
  muiDocs: 'https://mui.com/material-ui/react-divider/',
  a2uiEquivalent: 'Separator',
  importPath: '@/atoms/Divider',
  optionalProps: ['orientation', 'flexItem', 'textAlign', 'variant', 'children'],
  supportedStates: ['horizontal', 'vertical', 'with-text'],
  designTokens: ['colors'],
  accessibility: ['Decorative dividers are role="separator"; avoid relying on them to convey meaning.'],
  usageExamples: ['<Divider />', '<Divider orientation="vertical" flexItem />'],
  antiPatterns: ['Do not overuse dividers; prefer spacing for grouping.'],
  llmSafe: true,
  whenToUse: ['Separating list items or sections'],
  whenNotToUse: ['Creating layout columns (use Grid/Stack)'],
});

export default dividerMeta;
